export class TrainingStageCondition {
    constructor(eventNames) {
        this.eventNames = [];
        this.eventNames = eventNames;
    }
    evaluate(context) {
        const occurredEvent = context.currentEvent;
        // iterate through occurred events
        if (occurredEvent !== undefined) {
            if (!Array.isArray(this.eventNames)) {
                // case of a single event name
                if (occurredEvent.id === this.eventNames) {
                    return true;
                }
            }
            else {
                // case of multiple event names
                // if one of the event names match, return true
                for (const eventName of this.eventNames) {
                    if (occurredEvent.id === eventName) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}
